import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const headerMixBlend = () => {

  const header = document.querySelector('.header')
  const firstSection = document.querySelector('main > *')

  ScrollTrigger.create({
    trigger: firstSection,
    start: 'top top+=60px',
    end: 'bottom top+=61px',
    onEnterBack: () => {
      header.setAttribute('data-mix', 'false')
    },
    onLeave: () => {
      header.setAttribute('data-mix', 'true')
    },
  })
  
}

export default () => {}